const coverCard = [
{
  cardName: "",
  artist: "",
  songTitle: "",
  divinatoryMeaning: "",
  description: "", 
  welcomeText: 
  "<h3 style=\"text-align: center\">Welcome to the Charming Disaster"  
  +"<br />Software Apocalypse</h3>"  
  +"<p>Use the 'Search' button below to search the deck for the card you desire.</p>"
  +"<p>Double-tap or double-click the card image to reveal divinatory information.</p>"
  +"<p>and don't forget...</p>"
  +"<h3>The robots are still in charge!</h3>" 
  +"",
  image: require('./images/cards/00-cover.jpg')
}
]
export default coverCard;